import { useRef } from "react";
import { motion, useInView } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const MaskedLine = ({ children, delay = 0, className = "", as = "div", testId, immediate = false }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-8%" });
  const show = immediate || inView;
  return (
    <span ref={ref} className={`block overflow-hidden ${className}`}>
      <motion.div
        data-testid={testId}
        initial={{ y: "110%" }}
        animate={show ? { y: 0 } : { y: "110%" }}
        transition={{ duration: 0.9, ease: EASE, delay }}
      >
        {children}
      </motion.div>
    </span>
  );
};

export const FadeUp = ({ children, delay = 0, className = "", testId, y = 32 }) => (
  <motion.div
    data-testid={testId}
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-8%" }}
    transition={{ duration: 0.85, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ overline, title, body, dark = false, align = "left", testId }) => (
  <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    <FadeUp testId={testId ? `${testId}-overline` : undefined}>
      <p className={`jx-overline ${dark ? "text-jx-magenta" : "text-jx-purple"}`}>{overline}</p>
    </FadeUp>
    <MaskedLine delay={0.08} className="mt-5">
      <h2
        data-testid={testId ? `${testId}-title` : undefined}
        className={`font-display font-bold tracking-tighter leading-[1.02] text-4xl sm:text-5xl lg:text-6xl ${dark ? "text-white" : "text-jx-ink"}`}
      >
        {title}
      </h2>
    </MaskedLine>
    {body && (
      <FadeUp delay={0.18} className="mt-6" testId={testId ? `${testId}-body` : undefined}>
        <p className={`text-base sm:text-lg leading-relaxed ${dark ? "text-white/60" : "text-jx-ink/60"}`}>{body}</p>
      </FadeUp>
    )}
  </div>
);
